var _rect, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIconh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#36A6A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.0001C0.280051 10.2846 -2.16667 10.6667 -3 11.0001V13.5C-1.83333 13.5 0.631789 14.0439 2 14.5C8 16.5 11 15 13 12.5C14.8019 10.2476 18.6667 4.16667 20 1L12.5 -1.5L10 6.5C9.16667 8.33336 8 12 3.5 11.0001Z",
    fill: "#179593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5001C7.28005 17.7846 -0.666667 17.6667 -1.5 18L0 19.5C1.16667 19.5 7.5 20.5 9 22C13.4721 26.4721 18 22.5 20 20C21.8019 17.7476 25.6667 11.6667 27 8.5L23 4L17.5 14C16 16 15 19.5 10.5 18.5001Z",
    fill: "#179593"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0586 8.25C14.6173 8.25 15.1548 8.47083 15.5502 8.86708C15.9461 9.2625 16.1673 9.79583 16.1673 10.3542V13.6458C16.1673 14.8083 15.2215 15.75 14.0586 15.75H9.94232C8.7794 15.75 7.83398 14.8083 7.83398 13.6458V10.3542C7.83398 9.19167 8.77523 8.25 9.94232 8.25H14.0586ZM14.7215 10.975L14.7548 10.9417C14.8544 10.8208 14.8544 10.6458 14.7502 10.525C14.6923 10.4629 14.6127 10.425 14.5298 10.4167C14.4423 10.4121 14.359 10.4417 14.2961 10.5L12.4173 12C12.1757 12.2004 11.8294 12.2004 11.584 12L9.70898 10.5C9.5794 10.4042 9.40023 10.4167 9.29232 10.5292C9.17982 10.6417 9.16732 10.8208 9.26273 10.9458L9.31732 11L11.2132 12.4792C11.4465 12.6625 11.7294 12.7625 12.0257 12.7625C12.3211 12.7625 12.609 12.6625 12.8419 12.4792L14.7215 10.975Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconh);
export default __webpack_public_path__ + "static/media/mailIconh.0916e681b9dc4f2749a8324d0dadf541.svg";
export { ForwardRef as ReactComponent };